import styled from 'styled-components';
import React from 'react';
import ReactTooltip from 'react-tooltip';

const TooltipCustom = styled(ReactTooltip)`
  background-color: #f5f5f9 !important;
  border: 1px solid #dadde9 !important;
  &&&.place-left::after {
    border-left: 8px solid #f5f5f9 !important;
  }
  &&&.place-right::after {
    border-right: 8px solid #f5f5f9 !important;
  }
  &&&.place-top::after {
    border-top: 8px solid #f5f5f9 !important;
  }
  &&&.place-bottom::after {
    border-bottom: 8px solid #f5f5f9 !important;
  }
  color: rgba(0, 0, 0, 0.87) !important;
  font-family: Helvetica, sans-serif !important;
  font-size: 18px !important;
  line-height: 19px;
`;

const Tooltip = ({ tooltipId }) => <TooltipCustom id={tooltipId} />;

export default Tooltip;
